import { connect } from "react-redux";
import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import AlertModal from "./AlertModal";
import "./Modal.css";
import "./SettingsDialog.css";
import DataBase from "../../dataBase/liquidGuides";

class SettingsDialog extends Component {
  constructor(props) {
    super(props);
    let distance_unit = typeof props.user_info.distance_unit == "undefined" ? "miles" : props.user_info.distance_unit;
    let date_format = typeof props.user_info.date_format == "undefined" ? "Month first" : props.user_info.date_format;
    let edit_mode = typeof props.user_info.edit_mode == "undefined" ? "On" : props.user_info.edit_mode;
    let advanced_mode = typeof props.user_info.advanced_mode == "undefined" ? "Off" : props.user_info.advanced_mode;
    let travel_payouts_marker =
      typeof props.user_info.distance_unit == "undefined" ? "" : props.user_info.travel_payouts_marker;
    let payment_info = typeof props.user_info.payment_info == "undefined" ? "" : props.user_info.payment_info;
    let affiliate_program =
      typeof props.user_info.affiliate_program == "undefined" ? false : props.user_info.affiliate_program;
    let default_duration =
      typeof props.user_info.default_duration == "undefined" ? 30 : props.user_info.default_duration;
    let event_time_rounding =
      typeof props.user_info.event_time_rounding == "undefined" ? "15" : `${props.user_info.event_time_rounding}`;
    let home_airport = typeof props.user_info.home_airport == "undefined" ? "" : props.user_info.home_airport;
    this.state = {
      initial_distance_unit: distance_unit,
      initial_date_format: date_format,
      distance_unit: distance_unit,
      date_format: date_format,
      edit_mode: edit_mode,
      advanced_mode: advanced_mode,
      travel_payouts_marker: travel_payouts_marker,
      payment_info: payment_info,
      affiliate_program: affiliate_program,
      default_duration: default_duration,
      event_time_rounding: event_time_rounding,
      home_airport: home_airport,

      AlertModalShow: false,
      AlertModalTitle: "",
      AlertModalMessage: "",
      AlertModalButtons: [],
    };
  }

  componentDidMount() {}

  updateDistanceUnit = () => {
    this.setState({ distance_unit: this.state.distance_unit === "kilometers" ? "miles" : "kilometers" });
  };
  updateRounding = (value) => {
    this.setState({ event_time_rounding: value });
  };
  updateDateFormat = () => {
    this.setState({ date_format: this.state.date_format === "Day first" ? "Month first" : "Day first" });
  };
  updateEditMode = () => {
    this.setState({ edit_mode: this.state.edit_mode === "On" ? "Off" : "On" });
  };
  updateAdvancedMode = () => {
    this.setState({ advanced_mode: this.state.advanced_mode === "On" ? "Off" : "On" });
  };
  updateAffiliateProgram = () => {
    this.setState({ affiliate_program: !this.state.affiliate_program });
  };
  handleChangeDefaultDuration = (newText) => {
    if (isNaN(newText)) {
      if (newText !== "") newText = "";
    }
    this.setState({ default_duration: newText });
  };
  handleChangeTravelPayoutsMarker = (newText) => {
    this.setState({ travel_payouts_marker: newText });
  };
  handleChangePaymentInfo = (newText) => {
    this.setState({ payment_info: newText });
  };
  handleChangeHomeAirport = (newText) => {
    this.setState({ home_airport: newText.toUpperCase().replace(/[^A-Z]/g, "").slice(0, 3) });
  };

  _user_info = null;

  saveSettings = () => {
    if (this.props.user_info.uid == null) return;
    if (this.props.user_info.uid === "guest") {
      this.MyAlert("Cannot change settings in 'guest' mode");
      return;
    }
    let user_info = JSON.parse(JSON.stringify(this.props.user_info));
    user_info.distance_unit = this.state.distance_unit;
    user_info.date_format = this.state.date_format;
    user_info.edit_mode = this.state.edit_mode;
    user_info.advanced_mode = this.state.advanced_mode;
    user_info.travel_payouts_marker = this.state.travel_payouts_marker;
    user_info.payment_info = this.state.payment_info;
    user_info.affiliate_program = this.state.affiliate_program;
    user_info.default_duration = this.state.default_duration;
    user_info.event_time_rounding = parseInt(this.state.event_time_rounding);
    user_info.home_airport = this.state.home_airport;
    this._user_info = user_info;
    DataBase.updateUser(user_info, this.props.user_info_id, this.updateUserCallback);
  };

  updateUserCallback = (res) => {
    if (res.pass === true) {
      this.props.callback(this._user_info);
    } else {
      // updateUser's callback shape is { pass, res } — res is either a plain
      // string (e.g. "user is null") or the caught Firestore Error object
      // (which carries the real reason on .message). Was reading res.message
      // directly, which doesn't exist on this shape, so every failure showed
      // "Unknown error" regardless of the real cause.
      let msg = typeof res.res === "string" ? res.res : res.res?.message || "Unknown error";
      this.MyAlert(`Error updating user: ${msg}`);
    }
    this.props.onHide();
  };

  MyAlert = (message) => {
    this.setState({
      AlertModalTitle: "Message",
      AlertModalMessage: message,
      AlertModalButtons: [{ Title: "OK", Method: null }],
      AlertModalShow: true,
    });
  };

  render() {
    const SegBtn = ({ value, current, onClick, children }) => (
      <button
        className={`sd-seg-btn${current === value ? " sd-seg-btn--active" : ""}`}
        onClick={onClick}
      >
        {children}
      </button>
    );

    return (
      <div className="modal">
        <Modal
          show={this.props.show}
          animation={false}
          dialogClassName="sd-dialog"
          aria-labelledby="sd-title"
          centered
          onHide={this.props.onHide}
        >
          <Modal.Body style={{ padding: 0 }}>
            <div className="sd-shell">

              {/* ── Header ── */}
              <div className="sd-header">
                <div className="sd-header-icon">
                  <FontAwesomeIcon icon={solid("sliders")} />
                </div>
                <h2 className="sd-title" id="sd-title">Settings</h2>
                <div className="sd-header-actions">
                  <button className="sd-save" onClick={this.saveSettings}>
                    <FontAwesomeIcon icon={solid("check")} />
                    Save
                  </button>
                  <button className="sd-close" onClick={this.props.onHide}>
                    <FontAwesomeIcon icon={solid("xmark")} />
                  </button>
                </div>
              </div>

              {/* ── Body ── */}
              <div className="sd-body">

                {/* Preferences */}
                <span className="sd-section-label">Preferences</span>
                <div className="sd-card">
                  <div className="sd-row">
                    <span className="sd-row-label">
                      <FontAwesomeIcon icon={solid("pencil")} className="sd-row-icon" />
                      Edit Mode
                    </span>
                    <div className="sd-seg">
                      <SegBtn value="On" current={this.state.edit_mode} onClick={this.updateEditMode}>
                        On
                      </SegBtn>
                      <SegBtn value="Off" current={this.state.edit_mode} onClick={this.updateEditMode}>
                        Off
                      </SegBtn>
                    </div>
                  </div>
                  <div className="sd-divider" />
                  <div className="sd-row">
                    <span className="sd-row-label">
                      <FontAwesomeIcon icon={solid("sliders")} className="sd-row-icon" />
                      Advanced Mode
                    </span>
                    <div className="sd-seg">
                      <SegBtn value="On" current={this.state.advanced_mode} onClick={this.updateAdvancedMode}>
                        On
                      </SegBtn>
                      <SegBtn value="Off" current={this.state.advanced_mode} onClick={this.updateAdvancedMode}>
                        Off
                      </SegBtn>
                    </div>
                  </div>
                  <div className="sd-divider" />
                  <div className="sd-row">
                    <span className="sd-row-label">
                      <FontAwesomeIcon icon={solid("location-arrow")} className="sd-row-icon" />
                      Distance Unit
                    </span>
                    <div className="sd-seg">
                      <SegBtn value="miles" current={this.state.distance_unit} onClick={this.updateDistanceUnit}>
                        Miles
                      </SegBtn>
                      <SegBtn value="kilometers" current={this.state.distance_unit} onClick={this.updateDistanceUnit}>
                        Km
                      </SegBtn>
                    </div>
                  </div>
                </div>

                {/* Travel */}
                <span className="sd-section-label">Travel</span>
                <div className="sd-card">
                  <div className="sd-row">
                    <span className="sd-row-label">
                      <FontAwesomeIcon icon={solid("plane")} className="sd-row-icon" />
                      Home Airport
                    </span>
                    <input
                      className="sd-input"
                      type="text"
                      style={{ textTransform: "uppercase", width: "5em" }}
                      value={this.state.home_airport}
                      onChange={(e) => this.handleChangeHomeAirport(e.target.value)}
                      placeholder="e.g. LAX"
                      maxLength={3}
                    />
                  </div>
                  <div className="sd-hint">Used as the default starting airport for the Flight Cost Map and Flight Cost Calendar.</div>
                </div>

                {/* Schedule */}
                <span className="sd-section-label">Schedule</span>
                <div className="sd-card">
                  <div className="sd-row">
                    <span className="sd-row-label">
                      <FontAwesomeIcon icon={solid("clock")} className="sd-row-icon" />
                      Default Event Duration
                    </span>
                    <div className="sd-duration-wrap">
                      <input
                        className="sd-input"
                        type="text"
                        value={this.state.default_duration}
                        onChange={(e) => this.handleChangeDefaultDuration(e.target.value)}
                      />
                      <span className="sd-unit">min</span>
                    </div>
                  </div>
                  <div className="sd-divider" />
                  <div className="sd-row sd-row--stacked">
                    <span className="sd-row-label">
                      <FontAwesomeIcon icon={solid("stopwatch")} className="sd-row-icon" />
                      Event Time Rounding
                    </span>
                    <div className="sd-seg">
                      {["0", "5", "10", "15", "30"].map((v) => (
                        <SegBtn key={v} value={v} current={this.state.event_time_rounding} onClick={() => this.updateRounding(v)}>
                          {v} min
                        </SegBtn>
                      ))}
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </Modal.Body>
        </Modal>
        <AlertModal
          show={this.state.AlertModalShow}
          onHide={() => this.setState({ AlertModalShow: false })}
          AlertModalTitle={this.state.AlertModalTitle}
          AlertModalMessage={this.state.AlertModalMessage}
          AlertModalButtons={this.state.AlertModalButtons}
        />
      </div>
    );
  }
}

export default SettingsDialog;
